/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { PolicyPageStoryContent } from '../types/policy-page'

export const privacyFallback: StoryData<PolicyPageStoryContent> = {
  name: 'Privacy Policy',
  created_at: '2023-02-15T13:48:13.364Z',
  published_at: '2025-10-21T11:03:25.560Z',
  id: 261685447,
  uuid: '1c8b05c2-026e-4f6e-b0c7-784628ed7c1c',
  content: {
    _uid: '6078fdd5-08df-42cf-b493-c9a935e58731',
    body: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [
            {
              text: 'We’re removing the faff from changing and managing cars, and we also want to make our legal documents a cinch for anyone to understand. If you have any doubts or suggestions regarding any of them, please contact us and we’ll do our best to help.',
              type: 'text',
              marks: [
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: 'We don’t ask for any personal data from you in order to browse cars on the cinch website or using our app. However, when you’re browsing, we’ll use cookies that collect information about your preferences (including information you give to us to help improve your search results) and information about your computer or device. For more information about our use of cookies, please see our ',
              type: 'text',
            },
            {
              text: 'Cookie Policy',
              type: 'text',
              marks: [
                {
                  type: 'link',
                  attrs: {
                    href: 'https://www.cinch.co.uk/policies/cookie-policy',
                    uuid: null,
                    anchor: null,
                    target: '_self',
                    linktype: 'url',
                  },
                },
              ],
            },
            {
              text: ' .',
              type: 'text',
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: 'If you decide to give us your personal data, including when you create an account and purchase a car from us, then the idea of this Privacy Notice is to help you understand what personal data we have, how we use it, where it goes, and your rights to decide what happens with it. We will use personal data about you only for the reasons that you provided it, and in line with all applicable laws and what’s explained in this Privacy Notice.',
              type: 'text',
              marks: [
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: 'This Privacy Notice may change from time to time, for example because of developments in technology, our business, or the law, so please check back when you visit cinch for the most current information. If we have your e-mail address, we may also notify you of any changes via e-mail.',
              type: 'text',
              marks: [
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: '  ',
              type: 'text',
              marks: [
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: 'Last updated: 21st October 2025',
              type: 'text',
              marks: [
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Faff-free Privacy Notice',
    clauses: [
      {
        _uid: 'bb3e0e8b-7fd4-4354-8d1c-9da6a7d6dd10',
        body: [
          {
            _uid: 'f0a59f8f-ab13-4f6f-8caa-9b173efc3070',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'A "controller” is the organisation that decides on the purposes and ways that your personal data is processed (or, in other words, used). cinch’s website and services are provided by, and these decisions are made by:',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Cinch Cars Limited of',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Form 2',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '18 Bartley Wood Business Park',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Bartley Way',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Hook',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Hampshire',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'RG27 9XA',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Email: ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'DPO-Office@cinch.co.uk',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'mailto:DPO-Office@cinch.co.uk',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: ' ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'When we share personal data with third parties (see Section 6 below), they may become a controller in respect of their own processing activities. We recommend you read their privacy notices as these will apply to their use of your personal data. We can’t take any responsibility for what’s in those notices though. In this Privacy Notice we have included links to the privacy notices of the third parties we work with for easy access. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'At cinch we sell used cars however our website and app may also advertise new vehicles for sale that are available to purchase from Marshall Motor Group Limited (Marshall). Marshall and cinch are part of the same group of companies. If you express an interest in buying a new car from Marshall, we’ll share your personal data with Marshall so they can contact you directly. Marshall will be a separate controller to cinch in this case and so you should also read the Marshall privacy notice if you’re interested in a new car and ensure you are comfortable with how Marshall will also process your personal data separately to cinch. You can access the Marshall privacy notice ',
                      type: 'text',
                    },
                    {
                      text: 'here.',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.marshall.co.uk/site/privacy-notice/',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: '1. Who is the controller of your data?',
        component: 'ClauseSection',
      },
      {
        _uid: '2e1f2802-780f-415f-ae09-0dc96a0c02d2',
        body: [
          {
            _uid: '03289b9f-fd7f-43c8-ad21-379fa5b61f22',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'The types of personal data we process and the reasons for which we process it depends on how you’re using cinch. We are required to have a ‘lawful basis’ that we rely on to use your personal data in the ways we describe below, and we’ve stated what this is under each section.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
          {
            _uid: '83eb951f-1d01-428b-bbea-37aadac381cf',
            faqs: [
              {
                _uid: '36a4ccfa-46a8-429a-9789-4875dc606190',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: "If you choose to download and install the cinch app, you’ll be able to create an account, browse and purchase a car, and apply for finance in the same way as if you visit the cinch website.  We’ll collect and use your personal data for the same purposes explained in this Privacy Notice. In addition, we'll provide useful information through the app, such as the MOT due date for your car and a summary of your finance agreement and term remaining, if you have taken out finance through cinch.",
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Device level permissions are needed when the app is installed, in order to access file storage to upload documents for finance applications.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We also use cookies and similar technologies in our app. Some are necessary and cannot be switched off. Other cookies are optional for marketing purposes. You can control the use of these at any time by visiting Settings in the app. More information on our use of cookies is available in our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Cookie Policy',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/cookie-policy',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: '.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Using the cinch app',
                component: 'AccordionItem',
              },
              {
                _uid: 'c8bbc1c6-2b5d-4cbe-8dcd-fda6fb068286',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'To create an account we’ll need:',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- your name;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- e-mail address; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- a password.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Other than that, you aren’t obliged to provide any more personal data, but in addition to the above, you are able to enter the following:',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Your phone number; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Your marketing preferences',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: "You can also save favourites to your account. As part of this function, we will keep you informed if the car's price changes or if the car is no longer available.",
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'As explained in our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Cookie Policy',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/cookie-policy',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ', if you allow the use of cookies we’ll also use this data to create a personalised cinch profile to tailor our content, both on our website and in our marketing communications.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' performance of a contract (namely, our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Terms of Use',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/terms-of-use',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ') and our legitimate interests in creating a personalised cinch profile for you, to allow you to manage your account, store your favourite search results and view your order history, and for us to communicate with you about your favourited cars.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          type: 'hard_break',
                        },
                      ],
                    },
                  ],
                },
                title: 'Creating and managing your cinch account',
                component: 'AccordionItem',
              },
              {
                _uid: '90ef0732-f59a-40d3-a53f-1780bc45b1ec',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We may use your personal data to send you marketing by post, by phone, by email and by SMS message. You will always be in full control of any marketing we provide to you.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' We will only use your personal data for marketing purposes if we have your consent or a legitimate interest, depending on how and when we have collected your details (for example via a third party such as our event sponsorship partners, or when you create an account with cinch). ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Where we provide newsletters, marketing communications or other offers or information, we’ll use your data to tailor and send these to you, until you change or cancel your marketing preferences.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' where we have a lawful basis to provide you with newsletters,  marketing communications or other offers or information from us,  we rely on our legitimate interests where we tailor those communications to suit your preferences – we do this so that we can provide you with communications and offers that are relevant to you.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Using your personal information for marketing purposes',
                component: 'AccordionItem',
              },
              {
                _uid: '75203c9d-b8d2-4f6e-81b1-0a4a8c4c52b6',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We’ll analyse captured data and share certain personal data with third parties to expand our knowledge of customer categories, use and habits though matching the personal data we collect with other databases. Allowing us to create a more personalised experience for different customer segments and improve cinch. ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ': where we have a lawful basis to provide you with marketing, we rely on our legitimate interests to share the data we collect such as name, postcode, address and telephone number with credit agencies and customer matching databases. This enables us to understand our customers better and improve cinch in line with customer expectations.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Creating a more personalised experience',
                component: 'AccordionItem',
              },
              {
                _uid: '0f536d91-7307-407a-965a-c17894502c6f',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you receive any marketing communications from cinch and don’t wish to receive such information in future, then please log in to your account to change your preferences, call us or email us at ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'hello@cinch.co.uk',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'mailto:hello@cinch.co.uk',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '. You will also have the opportunity to opt out of future communications whenever cinch sends you any such material, using the instructions provided.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Managing your marketing preferences',
                component: 'AccordionItem',
              },
              {
                _uid: '4c5d08b8-c457-4c7d-b161-0387bece0aae',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'When you find a car that you would like to buy from cinch, we’ll need the following information from you to enter into the contract of sale with you, process the payment and arrange delivery or collection (as applicable) and to pick up your part exchange car if applicable.:',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Name',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Mobile phone number',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- E-mail address',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Current address (we’ll ask for your proof of address upon delivery or collection too by asking for a photocard UK driving licence or other form of ID accepted by us)',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Payment details',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If the registered keeper of the part exchange car is not you then we will also need this information from the registered keeper and this Privacy Notice will apply to our use of their data as well.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' performance of a contract (namely, our ',
                          type: 'text',
                        },
                        {
                          text: 'Car Purchase Terms and Conditions',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/terms-and-conditions',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ')',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/terms-and-conditions',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                          ],
                        },
                        {
                          text: '.',
                          type: 'text',
                        },
                      ],
                    },
                  ],
                },
                title: 'Selling a car to you',
                component: 'AccordionItem',
              },
              {
                _uid: 'f57fcfc9-1068-4db3-a276-b95bdb6aa246',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you would like to receive an indication of your financial eligibility, you can choose to carry out a ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'soft credit search',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' (which is arranged via our third party broker, Evolution Funding). We’ll need to collect the following information from you which we will provide to Evolution Funding:',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Full name',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Date of birth',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Current address',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Previous addresses if less than 3 years at current address',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Residential status',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Gross annual income ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' performance of a contract. To provide you with the requested information on your financial eligibility when looking to purchase a car with cinch. We collect this information on behalf of our third-party finance broker, Evolution Funding who carries out the eligibility check. You can view the ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'privacy notice',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.evolutionfunding.com/public/privacy-notice/',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ' or information about how they use your data, including the section on "',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Conducting Credit Searches.',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.evolutionfunding.com/public/customer-data-processing/',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: '"',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title:
                  'Helping to check your financial eligibility to purchase a car',
                component: 'AccordionItem',
              },
              {
                _uid: 'f32abb35-c46f-48e0-aa38-cd1060c391fe',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you would like to purchase a car using our finance option (which is arranged via our third party finance broker, Evolution Funding), we’ll need to collect the following personal data from you which we will provide to Evolution Funding and, in some cases, Black Horse (a lender):',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Title;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Full name (including middle names);',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Gender;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Date of birth;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Marital status;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Nationality;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Previous addresses if less than 3 years at current address;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Employment type and history;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Employer address;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Time with employer;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Mobile phone number;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Residential status;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Driving licence type;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Outgoings (including monthly mortgage/rent and other general outgoings);',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Gross annual income;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Type of proof of income;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Bank account number and sort code; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Number of years you have held that bank account',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '  ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis: ',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'We collect this personal data on behalf of our third party finance broker, Evolution Funding, and you can view their ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'privacy notice',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.evolutionfunding.com/public/privacy-notice/',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ' for information about how they use your data independently to cinch. Our third party finance broker will also share your personal data with lenders considering your finance application. We may also share your data directly with Black Horse where you meet their eligibility criteria. Where this applies to you, you should also view their ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'privacy notice',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.blackhorse.co.uk/privacy',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.blackhorse.co.uk/privacy',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'for information about how they use your data independently to cinch.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '  ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Credit Reference Agencies ',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'You should note in particular that our third party finance broker, or the lender that is considering your finance application, will carry out credit and identity checks on you, and will supply your personal data to credit reference agencies (CRAs) who will in turn give them information about you as an output to the credit and identity check.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'CRAs will supply to them both public (including the electoral register) and shared credit, financial situation and financial history information and fraud prevention information. When CRAs receive a search from them, the CRA will place a search footprint on your credit file that may be seen by other lenders. Our third party finance broker or lender do this to assess your creditworthiness and product suitability, to check your identity, manage your account, trace and recover debts and prevent criminal activity.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'The finance broker or lender will also continue to exchange personal data about you with CRAs on an ongoing basis, including about your settled accounts and any debts not fully repaid on time. CRAs will share your personal data with other organisations. Your personal data will also be linked to the data of your spouse, any joint applicants or other financial associates. The identities of the CRAs, and the ways in which they use and share personal information, are explained in more detail at ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Equifax',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.equifax.co.uk/crain',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ', ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Experian',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.experian.co.uk/crain',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ' and ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Transunion',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.transunion.co.uk/legal/consumer-centre#pc-credit-reference',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: ' (please note that the Credit Reference Agency Information Notice or ‘CRAIN’ is the same for each of the CRAs).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Your lender will tell us your application ID number and will keep us up to date with the progress and outcome of your finance application so that we can enter into the contract of sale with you at the appropriate time.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '  ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Verifying your identity',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you choose to purchase a car using our finance option and your finance application is approved by Black Horse then before you can proceed with entering into the finance agreement, we are required to verify your identity on behalf of Black Horse. In order to do this, we will need to collect a “selfie” photograph of you and an image your identity document such as a driving licence. We will use a third party to carry out this identity check who will collect your photograph and document image as well as certain device and location identifiers such as an IP address in order to help correctly identify you and reduce fraud.  ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ': compliance with the legal obligations regarding verification of identity imposed by anti-corruption laws, our legitimate interest in reducing fraud and the performance of a contract (namely your finance agreement with Black Horse).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title:
                  'Helping to arrange financing for your purchase of a car',
                component: 'AccordionItem',
              },
              {
                _uid: '1bc770e1-14e2-4053-b6dc-3701e7edfd5a',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'During the term of your finance agreement, we may contact you to discuss finance options we believe may be relevant to you, including renewal, voluntary termination, balloon payments, early settlement and the options available at the end of a finance agreement. This is based on personal data we receive from your lender, relating to your outstanding balance or early settlement requests, where there is a lawful basis for them to share this personal data with us.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you do not wish us to contact you in this way, please see ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Managing your marketing preferences',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/privacy#model-faq-button-5',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' to unsubscribe.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis: ',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Permission to provide marketing materials to you, which may be based on consent or legitimate interests, depending on how and when we have collected your details',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Contacting you about finance options',
                component: 'AccordionItem',
              },
              {
                _uid: 'f6776264-4dc3-4dda-83e8-2a8c7ff0b676',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'When we communicate with you about the purchase of your car, or if you contact us with a query or complaint, then we will collect and process your personal data and keep records of our interactions with you (e.g. calls, e-mails, chat sessions, letters), as needed to investigate and provide you an answer or resolution. You may also optionally provide your postcode or location of your nearest town, to enable us to advise on handover, collection or delivery options, and the location of your nearest cinch Store. Please note we may record calls and keep records of them and the contents of e-mails.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' performance of a contract (namely, our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Terms of Use ',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/terms-of-use',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                        {
                          text: 'Car Purchase Terms and Conditions',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/terms-and-conditions',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ', ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '90',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Day',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Warranty',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Terms',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'and Conditions, GAP agreement and/or cinchCare agreement, as applicable',
                          type: 'text',
                        },
                        {
                          text: ')',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'and our legitimate interests in ensuring that we are able to answer or resolve any queries or complaints properly and efficiently.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Providing customer service and quality control',
                component: 'AccordionItem',
              },
              {
                _uid: '77412cca-5c95-49d5-8186-e90ea940630c',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you enter a promotion, contest, or prize draw then we will collect and process your personal data in order to manage your entry. We may at the same time give you the opportunity of signing up for an account or opting in to receiving marketing communications but will only use your personal data for that purpose if you choose to do so.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Depending on the nature of the promotion we may ask you for personal data in order for you to make a claim or participate, including your name, address, email address, bank account and sort code and other follow up information in case of any queries.  ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' performance of a contract, namely our contractual obligations under the terms of the relevant promotion, contest or prize draw – we do this so that we can identify you, to correspond with you regarding the promotion, contest or prize draw, verify your claim is valid and to make any applicable payments or distribute prizes to you (if required).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Running promotions, contests or prize draws',
                component: 'AccordionItem',
              },
              {
                _uid: 'fc5e904d-6855-4c55-8937-5352d54ed14f',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We might contact you from time to time to provide feedback on our services.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' our legitimate interest in order to continually improve the products and services that we offer.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Market research, surveys and testimonials',
                component: 'AccordionItem',
              },
              {
                _uid: 'b2706b5e-ee2d-4e9b-85ac-00bbacb42d8e',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We may need to contact you in relation to service-related issues, e.g. forgotten account details, technical issues with the service, updates to our terms and conditions, or other non-promotional messages.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' our legitimate interests in ensuring that you can continue to use cinch and are aware of our current policies and procedures.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Service communications',
                component: 'AccordionItem',
              },
              {
                _uid: '3ea4a199-62e8-4293-8975-85cf37bf1dba',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'It’s important for us to understand how people use cinch so that we can improve and ensure our users receive a good service. We’ll analyse which pages or parts of the website get the most views or attention, and how our users arrive here, so that we can improve. This may include collecting details about your device and network, such as browser version, IP addresses, operating system details, and screen size.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'This may also involve the use of cookies or similar technologies as explained in our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Cookie Policy',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/policies/cookie-policy',
                                uuid: null,
                                anchor: null,
                                target: '_blank',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'underline',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' our legitimate interests in maintaining and optimising our website and improving it where necessary or as identified by trends in the user personal data we analyse, including for security purposes and to protect your information.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Improving cinch',
                component: 'AccordionItem',
              },
              {
                _uid: '03d2aca4-568f-4f0e-a3a9-4a017f992959',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We’ll use your personal data to assist any public authority or criminal investigation body, for activities relating to the prevention, detection and investigation of crime, for compliance with our legal and regulatory responsibilities, to identify you when you contact us, to comply with a request from you in connection with the exercise of your rights under data protection laws, and to verify the accuracy of personal data we hold about you.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis:',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ' compliance with a legal obligation.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Complying with our legal obligations',
                component: 'AccordionItem',
              },
              {
                _uid: 'ff65a5c5-ca97-43be-9150-b465065f47f0',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Under data protection laws, certain “special categories” of personal data are subject to additional protections – this includes data relating to health. We don’t ask you for this type of personal data or intentionally collect it, however if you disclose to us that you have a disability (physical or mental) we might disclose this personal data to our third party finance broker who may tell the relevant lender. This is to make sure we are complying with our legal and regulatory obligations and to evidence that we’ve taken appropriate steps to protect you in the case of a legal claim.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'cinch does not intend to collect or process any other special categories of personal data e.g. those revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, genetic data or biometric data, or data concerning anyone’s sex life or sexual orientation.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: '“Special categories” of data',
                component: 'AccordionItem',
              },
            ],
            title: '',
            component: 'FaqSection',
          },
        ],
        title:
          '2. Why do we process personal data? What data do we process? And what is our lawful basis for that processing?',
        component: 'ClauseSection',
      },
      {
        _uid: '11b13557-8306-434a-bf30-5fbf4ddec0ce',
        body: [
          {
            _uid: 'b612b59b-98e4-4308-8104-230384f37191',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Together with your car purchase, cinch also offers a number of additional products and services, including through third parties. This section explains how we use and share personal data for these purposes.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
          {
            _uid: 'b1c2cba1-b19b-4481-b061-ab2dfc05a4ac',
            faqs: [
              {
                _uid: 'ff8fbfe9-ed90-4da7-adc1-76720ec40e3f',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'When you purchase',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'a car',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'from cinch,',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'a 90-day',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'warranty for',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'mechanical',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'and electrical',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'repairs',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'to',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'the',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Car',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'is',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'provided',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'at',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'no',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'additional',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'cost',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'to',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'you.',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'This',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'includes breakdown',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'assistance',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '(where',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'the',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'breakdown',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'results',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'from',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'mechanical',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'or ',
                          type: 'text',
                        },
                        {
                          text: 'electrical defect).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'you make',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'a',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'claim',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'under',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'our',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '90-day',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'warranty,',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'we’ll',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'share',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'your',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'personal data',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'and that',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'of',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'any',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'other',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'person',
                          type: 'text',
                        },
                        {
                          text: ' you provide (as ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'required',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'to process',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'your',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'claim)',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'with',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'our ',
                          type: 'text',
                        },
                        {
                          text: 'authorised repairers and/or our breakdown agent, as is necessary to ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'provide',
                          type: 'text',
                        },
                        {
                          text: ' the benefits of the 90-day warranty to ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'you,',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'which',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'may',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'include:',
                          type: 'text',
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Name;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'contact number; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'car registration number (where this is personal data).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Where',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'it',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'is',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'necessary',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'for',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'you',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'to',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'provide',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'someone',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: "else's",
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'personal',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'data',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'as',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'part',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'of',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'a ',
                          type: 'text',
                        },
                        {
                          text: 'claim',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '(for example',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'a',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'family',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'member or other driver of',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'the',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'car)',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'please',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'ensure',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'they',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'are ',
                          type: 'text',
                        },
                        {
                          text: 'aware their information will be processed in accordance with this Privacy Notice, and have agreed you may share this information on their behalf (before you provide their personal data to us or our partners).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Please',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'see',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'the',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Data',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Protection',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'section',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'in',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'the',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'cinch',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '90',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Day',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Warranty',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Terms',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'and Conditions',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'available',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'here',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/90-day-warranty-termsandconditions.pdf',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '#1565BF',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '#1565BF',
                              },
                            },
                          ],
                        },
                        {
                          text: 'for',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'more',
                          type: 'text',
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'information.',
                          type: 'text',
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ': performance of a contract (namely our ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: '90-Day Warranty Terms and Conditions',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/90-day-warranty-termsandconditions.pdf',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'bold',
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '#0070C0',
                              },
                            },
                          ],
                        },
                        {
                          text: ')',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Operating our 90-day warranty',
                component: 'AccordionItem',
              },
              {
                _uid: 'd89c9129-05cd-4929-b911-d673a19f8411',
                body: {
                  type: 'doc',
                  content: [
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'We offer the following third party products and services, available for you to purchase through the cinch car purchase journey or your My Account function.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchShield',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' (provided by Altro Limited trading as Autoglym)',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchCharge',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' (provided by Paua Tech Limited)',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchCover ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: '(provided by London General Insurance Company Limited (',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'LGI',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ') and administered by TWG Services Limited (',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'TWG',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ')). LGI and TWG provide their services under the name “Assurant”. LGI is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, Financial Services Register No. 202689. TWG is authorised and regulated by the Financial Conduct Authority, Financial Services Register No. 312440. ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          type: 'hard_break',
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'The following ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'cinchCover',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' products and services are available for purchase:',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'Extended warranty and breakdown assistance;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '-',
                          type: 'text',
                        },
                        {
                          text: ' Alloy wheel insurance;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'Scratch and dent insurance; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- Tyre insurance.',
                          type: 'text',
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'GAP insurance',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' (also known as Asset Protection Insurance) (provided by Motors Insurance Company Limited (MICL) and administered by Car Care Plan Limited (CCP)). MICL and CCP provide GAP insurance under the “Autotrust” brand. MICL is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and Prudential Regulation Authority, under Financial Services Register No. 202875. CCP is authorised and regulated by the Financial Conduct Authority under Financial Services Register No. 309268. ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'How your personal data is used',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'If you opt to purchase any of the third party products and services described in this section, we may need to share the following personal data with these third parties in order to register your purchase and carry out administration tasks (such as re-directing complaints):',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'Title;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'name;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'current address;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'contact phone number and email address;',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: ' ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'car registration number (where this is personal data); and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'customer order ID (where this is personal data).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Lawful basis',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ': performance of a contract (to provide you with cinchShield, cinchCharge, cinchCover or GAP insurance at your request).',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'The third party that provides the product or service will be a controller of any personal data you provide to them. This means that the third party, not cinch, decides on the purposes and ways that your personal data is processed (or, in other words, used). cinch is not responsible for the actions of these third parties when processing your personal data.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Where these third party products or services apply to you, please review the privacy notice of each controller (as linked below) to ensure you’re comfortable with how that controller will process your personal data independently of cinch.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchShield',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' - ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Privacy Policy | Autoglym LifeShine',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://lifeshine.com/privacy-policy/',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: ';',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchCharge',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' - ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Paua | Privacy (pauatech.com)',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.pauatech.com/privacy-policy',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '; and',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'cinchCover',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' - ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'as set out in your policy wording documentation and their privacy policy - ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Privacy Policy | Assurant',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.assurant.co.uk/privacy-cookie-policy',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                        {
                          text: '.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: '- ',
                          type: 'text',
                        },
                        {
                          text: 'GAP insurance',
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                          ],
                        },
                        {
                          text: ' - ',
                          type: 'text',
                        },
                        {
                          text: 'Car Care Plan ',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Privacy and Cookies Notice',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://s3-eu-west-2.amazonaws.com/car-care-plan-staging/2024-06/CCP-PRIVACY-AND-COOKIES-NOTICE.pdf',
                                uuid: null,
                                anchor: null,
                                target: '_self',
                                linktype: 'url',
                              },
                            },
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                        {
                          text: '.',
                          type: 'text',
                          marks: [
                            {
                              type: 'styled',
                              attrs: {
                                class: '#2E2E2E',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                title: 'Third party products and services',
                component: 'AccordionItem',
              },
            ],
            title: '',
            component: 'FaqSection',
          },
        ],
        title: '3. Additional products and services',
        component: 'ClauseSection',
      },
      {
        _uid: 'f71d50a1-beae-4a60-8846-b7d1348de04d',
        body: [
          {
            _uid: '26a7ee32-4eb3-498f-888f-d0128d02134c',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'cinch doesn’t keep your personal data for any longer than necessary. If you have signed up for an account with cinch, then you will be able to access it and we will keep your personal data within it until you change it or cancel your account.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you buy a car from cinch, then we will keep personal data relating to the sale of a car, including your application for finance if you make one, for as long as it is necessary for us to comply with our legal obligations. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you purchase, or have the benefit of, any additional products and services (as set out in Section 3 above in the part entitled “Additional products and services”), cinch will keep your personal data (and that of any third parties provided) for as long as is necessary for us to provide you with those benefits, products and/or services.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '#2E2E2E',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'In relation to any promotions, contests or prize draws that you participate in, cinch will not keep your personal data for any longer than necessary to complete the promotion, contest or prize draw and pay and account for payments or distribute prizes, also allowing for a reasonable period for any queries or disputes to be raised and settled.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If we need to keep your data longer for tax, accounting, reporting, regulatory or legal reasons then we will use it only for those purposes and for a period that is reasonably necessary to comply with the laws and policies that apply to us and to be in a position to deal with any legal or regulatory claims.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'After these periods we may anonymise personal data (so it does not identify the individual to which it relates) to use it for research or statistical purposes and improving our website and services.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: '4. How long does cinch keep your data for?',
        component: 'ClauseSection',
      },
      {
        _uid: 'b90e32bb-6c99-4e8d-a126-19cd6293d067',
        body: [
          {
            _uid: '0b024114-54ad-42f7-9540-6ebbaaafc905',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We also advertise our cars on other websites. Some of these sites allow customers to request contact from cinch, and collect personal data to pass to us for this purpose.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If we receive personal data in this way, we will only use it for the purposes of contacting customers about the car they are interested in, unless the customer agrees to receive further contact from cinch or creates an account.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We also receive personal data from other affiliates and publishers. This allows us to track transactions to enable cashback to be paid in accordance with the terms and conditions of specific promotions, or where a customer referral has been received from a member of our affiliated publishing network. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you register for cinchCharge, we will receive personal data from the provider of cinchCharge in order for us to verify you as a customer of cinch, trace eligibility for promotional discounts and for internal reporting purposes.  ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you have purchased cinchCover, GAP insurance or cinchCare, we will receive personal data from the provider of that product in order for us to understand how claims are being handled by the provider and for internal reporting and accounting purposes. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you purchase GAP Insurance and subsequently make a claim where your car is a total loss, you can opt to have your personal data sent back to cinch so we can help you find a replacement vehicle. ',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Our sponsorship partners, and other third parties we work with who provide their own products and services to you at your option (as set out in Section 2 above in the part entitled “Third party products and services”), may present you with the opportunity to consent to receive marketing from cinch. Where you opt-in to cinch marketing in this way, our partner will transfer your personal data to us so we can market to you in accordance with your preferences. You can change your marketing preferences at any time by logging in to your account, calling us or email us at ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'hello@cinch.co.uk',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'hello@cinch.co.uk',
                            uuid: null,
                            anchor: null,
                            target: '_blank',
                            linktype: 'email',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: '. You will also have the opportunity to opt out of future communications whenever cinch sends you marketing material, using the instructions provided in that marketing material.   ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title:
          '5. Does cinch receive your personal data from any other third parties?',
        component: 'ClauseSection',
      },
      {
        _uid: 'd09842af-87e6-4261-92fb-2eb27a0bd791',
        body: [
          {
            _uid: 'c08462ca-22bc-4ee3-8a2b-128451a68f9a',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 5,
                  },
                  content: [
                    {
                      text: 'Obtaining finance',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you would like to purchase a car from cinch using our finance option, we’ll disclose certain personal data to our third party finance broker, Evolution Funding, and, in some cases, Black Horse (a lender). See Section 2 (the parts entitled “Helping to check your ﬁnancial eligibility to purchase a car” and “Helping to arrange ﬁnancing for your purchase of a car”) for full details.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'heading',
                  attrs: {
                    level: 5,
                  },
                  content: [
                    {
                      text: 'Arranging delivery and collection',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'When your order is ready for delivery or collection, we’ll share your name, address and contact details with our third party delivery service provider so that they can get your car to you. Our delivery service provider will carry out the checks explained in our ',
                      type: 'text',
                    },
                    {
                      text: 'Car Purchase Terms and Conditions ',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/terms-and-conditions',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'on you, your ordered car and your part exchange car (if applicable) on delivery or collection. Any personal data within this information will be shared with us so that we can manage the ongoing relationship with you.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'heading',
                  attrs: {
                    level: 5,
                  },
                  content: [
                    {
                      text: 'Expressing an interest in buying a new car from Marshall',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We may advertise new vehicles for sale on cinch that are available to purchase from Marshall Motor Group Limited (Marshall). Marshall and cinch are part of the same group of companies. If you express an interest in buying a new car from Marshall, we’ll pass your personal data to Marshall so they can contact you directly. Where this applies to you, please review the privacy notice of Marshall ',
                      type: 'text',
                    },
                    {
                      text: 'here',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.marshall.co.uk/site/privacy-notice/',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' which explains how Marshall will process your personal data independently of cinch.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'heading',
                  attrs: {
                    level: 5,
                  },
                  content: [
                    {
                      text: 'Additional products and services',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you make a claim under our 90-day warranty then we’ll disclose certain personal data to our authorised repairers and/or our breakdown agent, as is necessary to provide you with the benefits under those products. See Section 3 (the part entitled “Operating our 90-day warranty”) for full details.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you purchase cinchCover, cinchCare or GAP Insurance through cinch, your personal data will be disclosed to the provider of the product in order for your contract to be set up and administered.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If you have registered for cinchCharge, we will share your personal data with the provider of cinchCharge solely to the extent needed to validate that you are a cinch customer, trace eligibility for promotional discounts and for internal reporting purposes. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'From time to time we may provide other services or products through cinch that are not referenced above. Depending on the service or product, we may need to provide your contact details to the service provider, or confirm to the provider that you are a cinch customer. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'cinch also works with other organisations that provide services such as IT and data processing or other professional advisors. These include:',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'providers of IT-related services (e.g. data storage, website development, live chat, hosting, management, security or maintenance);',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'payment processing services;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'data processing companies that provide us with services such as call and e-mail tracking and recording, management of PR and customer communications, sending e-mails or texts, or processing of information or newsletters;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'organisations providing us with services relating to the management of promotions, contests and prize draws and fulfilment of payments and prizes;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'companies in our group or affiliated companies that provide us with additional technical infrastructure or services;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'data analysis providers (e.g. measuring which webpages or advertisements are of most interest); ',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'advertising affiliates as part of our affiliate publishing network, to track referrals and transactions; and',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'accounting, legal, insurance or banking service providers.',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'These organisations process personal data on our behalf, but our contracts with them oblige them to meet data protection standards as strict as the ones that apply to us, and not to use your personal data for any other purpose.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Where these third parties are not based in the UK or other countries that are officially regarded as having adequate data protection laws, then this will be done only on the basis of legal safeguards aimed at ensuring that your personal data is kept as secure as under applicable UK laws. Please contact us for more information about the safeguards we have in place.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Other circumstances where cinch may need to disclose your personal data to third parties could be: (i) where permitted or required by law, to any police force, court, regulator or public body; (ii) to enforce or apply the terms of our contracts or to protect the rights, property or safety of our customers; or (iii) in connection with a sale, merger or restructuring of our business or company.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: '6. Does cinch provide your personal data to any third parties?',
        component: 'ClauseSection',
      },
      {
        _uid: '406b4ff6-27a0-4ffd-802f-6f6801d96259',
        body: [
          {
            _uid: 'f3d3957d-509a-4095-a4fd-6f515a7e448c',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'cinch is committed to ensuring that you can easily exercise your legal rights over your personal data under the laws that apply to us.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'You are entitled to ask at any time:',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'ordered_list',
                  attrs: {
                    order: 1,
                  },
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'for access to a copy of the personal data that cinch holds about you;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'to have any incorrect personal data about you corrected (remember that you can update some of your data in your account);',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'for personal data about you to be erased (also referred to as the “right to be forgotten”) or if that is not possible (e.g. because the law requires us to keep data for longer) to have processing restricted;',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'to object to particular processing (e.g. for marketing purposes or where we rely on legitimate interests);',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'to contest a decision made about you based on automated processing (although cinch does not use any automated processing); and',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              text: 'to receive an electronic copy of personal data you provided to us, for provision to a different service provider (also referred to as “data portability”).',
                              type: 'text',
                              marks: [
                                {
                                  type: 'styled',
                                  attrs: {
                                    class: '',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'You are also able to withdraw any consent given by you in the past. If you withdraw your consent, any processing of the personal data that took place before you do so will still be legal.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'cinch can always be contacted using the details in Section 1 of this Privacy Notice to resolve any issues or doubts you may have in relation to processing of your personal data, or exercising your legal rights. If you believe that your rights have not been respected then you are also entitled to complain to the UK Information Commissioner (',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'www.ico.org.uk',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.ico.org.uk',
                            uuid: null,
                            anchor: null,
                            target: '_blank',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ').',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: '7. What are your rights in relation to your personal data?',
        component: 'ClauseSection',
      },
      {
        _uid: 'ba63ca15-db92-4e7f-a808-d2213ffec478',
        body: [
          {
            _uid: '60e08156-e605-4413-aa31-d6eb12641154',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'To search our database of cars you aren’t required to sign up for an account or enter any other personal data if you don’t want to. If you would like to purchase a car from us, then there’s certain personal data we need from you to make that happen – if we don’t have this, we can’t enter into a contract of sale with you. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If, on purchasing a car from us, you would like to benefit from, or purchase, additional products and services from us or the third parties we work with, then there’s certain personal data we need from you in order to provide that benefit, product or service – if we don’t have this personal data the provider of that benefit, product or service can’t enter into a contract with you.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Some of the cookies we use are ‘strictly necessary’ meaning that they are necessary to make certain parts of the website work – please see our ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'Cookie Policy',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/cookie-policy',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ' for more information.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: '8. Do you have to provide your personal data to cinch?',
        component: 'ClauseSection',
      },
      {
        _uid: '703b5fd6-44df-47fc-ac23-9bd9667f3fff',
        body: [
          {
            _uid: 'd8306408-41cb-4ec1-9600-c4a3e531ac59',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We operate within the UK. Some of our third party service providers may process personal data on our behalf in locations outside of the UK. When they do, we will ensure that appropriate safeguards are in place for that transfer and storage as required by applicable law. This is because some countries outside of the UK do not have data protection laws equivalent to those in the UK. If you would like more information about the safeguards we have in place, please contact our Data Protection team using the details in Section 1 of this Privacy Notice.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            quote: '',
            title: '',
            component: 'RichTextSection',
          },
        ],
        title: ' 9. Where does cinch store your data?',
        component: 'ClauseSection',
      },
    ],
    component: 'PolicyPage',
    cookiePolicy: [],
  },
  slug: 'privacy',
  full_slug: 'policies/privacy',
  sort_by_date: null,
  position: -230,
  tag_list: [],
  is_startpage: false,
  parent_id: 170758293,
  meta_data: null,
  group_id: '00fb6a39-f17c-41fa-a60f-21dd6af5c6bf',
  first_published_at: '2023-02-15T17:09:49.000Z',
  lang: 'default',
  alternates: [],
}
